import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/img/debutEnqueteSatisfactionModal.png'


const _hoisted_1 = {
  key: 0,
  class: "modal-content"
}
const _hoisted_2 = {
  key: 0,
  class: "pre-line"
}
const _hoisted_3 = {
  key: 1,
  class: "pre-line"
}
const _hoisted_4 = {
  key: 2,
  class: "modal-radio-options"
}
const _hoisted_5 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReglePastille = _resolveComponent("ReglePastille")!

  return (_ctx.societesLoaded)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_ReglePastille, { cle: "dashboard.sondageSatisfactionConditions" }),
        _cache[4] || (_cache[4] = _createElementVNode("img", {
          src: _imports_0,
          alt: "personne satisfaction"
        }, null, -1)),
        (_ctx.societes.length === 1)
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.$t('satisfaction.modal.part1', {libelleSociete: this.societeList})), 1))
          : (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.$t('satisfaction.modal.multisociete', {libelleSociete: this.societeList})), 1)),
        _createElementVNode("div", {
          class: _normalizeClass(["modal-buttons", { centered: _ctx.hideLaterButton }])
        }, [
          (!_ctx.hideLaterButton)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleLaterClick && _ctx.handleLaterClick(...args))),
                class: "btn-later"
              }, _toDisplayString(_ctx.$t('satisfaction.modal.btn.rptard')), 1))
            : _createCommentVNode("", true),
          (!_ctx.hideLaterButton)
            ? (_openBlock(), _createBlock(_component_ReglePastille, {
                key: 1,
                cle: "dashboard.sondageSatisfactionRelance"
              }))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.emitAnswer && _ctx.emitAnswer(...args))),
            class: "btn-repondre"
          }, _toDisplayString(_ctx.$t('satisfaction.modal.btn.rp')), 1)
        ], 2),
        (_ctx.showRadioOptions)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.radioOptions, (option, index) => {
                return (_openBlock(), _createElementBlock("label", { key: index }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.responseOption) = $event)),
                    value: option.value,
                    onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleRelanceSelection && _ctx.handleRelanceSelection(...args)))
                  }, null, 40, _hoisted_5), [
                    [_vModelRadio, _ctx.responseOption]
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.libelleRadio(option)), 1)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}